var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isValid)?_c('div',[_c('link-title',{attrs:{"url":_vm.url}}),_c('a',{attrs:{"href":_vm.url,"target":"_blank","title":_vm.url}},[_vm._v(_vm._s(_vm.url))])],1):_c('strong',[_vm._v(_vm._s(_vm.url))])])}
var staticRenderFns = []

export { render, staticRenderFns }